import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {SL4AnagrafService} from '../../../general-services/service-sl4-anagraf/sl4-anagraf.service';
import * as toastr from 'toastr';
import {L2Model} from '../../../../models/L2Model';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-l2-anagraf',
  templateUrl: './edit-sl4-anagraf.component.html',
  styleUrls: ['./edit-sl4-anagraf.component.scss']
})
export class EditSl4AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l2: L2Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  id: number;
  L2Cod: string;
  l2Json: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private sl4AnagrafService: SL4AnagrafService, private _Activatedroute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.l2Json = params['row'];
      });

    this.l2 = new L2Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.l2 = JSON.parse(this.l2Json) as L2Model;

    this.formValidator.patchValue({
      cod: this.l2 ? this.l2.cod : ''
    });

    this.formValidator.patchValue({
      description: this.l2 ? this.l2.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.id = params['id'];
      this.L2Cod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL4_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.l2.cod = this.formValidator.controls['cod'].value;
      this.l2.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.sl4AnagrafService.update(this.sl4AnagrafService.baseUrl, this.l2).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL4 Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          }else {
            toastr.success('SL4 was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL4_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
